import React from 'react';
import SpecialistsListView from '../features/specialists/views/specialists-list-view';
import ArticlesListView from "../features/articles/views/articles-list-view";
import PreviewArticleModal from "../features/articles/components/preview-article-modal";

const SpecialistsPage: React.FC = () => {
  return (
      <div className="w-full max-h-full overflow-y-auto">
          <div className="px-6 py-[80px] max-w-[848px] mx-auto">
              <SpecialistsListView/>
          </div>
      </div>
  );
};

export default SpecialistsPage;


